// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"89":"b16216a8","130":"fe95a7ce"}[chunkId] || chunkId) + "." + {"89":"859e4117d0ec8590","130":"054a0c5a9e0191b0","151":"3998aff5d09307dd","318":"5b75643a13843fb6","586":"d5a322d11a70d585","630":"c87cde03fa547400","805":"c39cf4c5d1c65307","969":"e609e783c12dbaf3"}[chunkId] + ".js";
};